import { render, staticRenderFns } from "./TotalLungsObserved.vue?vue&type=template&id=5d19670f&scoped=true&"
import script from "./TotalLungsObserved.vue?vue&type=script&lang=ts&"
export * from "./TotalLungsObserved.vue?vue&type=script&lang=ts&"
import style0 from "./TotalLungsObserved.vue?vue&type=style&index=0&id=5d19670f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d19670f",
  null
  
)

export default component.exports